// extracted by mini-css-extract-plugin
export var searchHeader = "_8r-0";
export var searchHeaderDark = "_8r-1";